import clsx from 'clsx';
import { forwardRef } from '@wordpress/element';
import { PolymorphicElement } from '../../utils/polymorphic-element';
import Label from './label';
import { useResizeLabel, POSITIONS } from './utils';
import styles from './style.module.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const noop = () => {};
function ResizeTooltip({
  as = 'div',
  axis,
  className,
  fadeTimeout = 180,
  isVisible = true,
  labelRef,
  onResize = noop,
  position = POSITIONS.bottom,
  showPx = true,
  zIndex = 1000,
  ...props
}, ref) {
  const {
    label,
    resizeListener
  } = useResizeLabel({
    axis,
    fadeTimeout,
    onResize,
    showPx,
    position
  });
  if (!isVisible) {
    return null;
  }
  const classes = clsx('components-resize-tooltip', styles.root, className);
  return /*#__PURE__*/_jsxs(PolymorphicElement, {
    "aria-hidden": "true",
    as: as,
    ...props,
    className: classes,
    ref: ref,
    children: [resizeListener, /*#__PURE__*/_jsx(Label, {
      "aria-hidden": props['aria-hidden'],
      label: label,
      position: position,
      ref: labelRef,
      zIndex: zIndex
    })]
  });
}
const ForwardedComponent = forwardRef(ResizeTooltip);
export default ForwardedComponent;